/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProfileDisplayPage } from '../pages/profile-display/profile-display.page';
import { LoginSharedPage } from '../pages/login-shared/login-shared.page';
import { LoginPage } from '../pages/login/login.page';
import { UserService } from '@shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class OpenProfileService {

  public souls: any[] = [];

  constructor(
    public modalCtrl: ModalController,
    private userService: UserService,
  ) { }

  public setSouls(souls: any[]): void {
    this.souls = souls;
  }

  async openProfile(soul: any): Promise<any[]> {
    try {
      console.log('OpenProfileFromLikes, soul:', soul);
  
      // Abre o modal com o perfil
      const modal = await this.createProfileModal(soul);
  
      // Processa a resposta do modal
      await this.handleModalResponse(modal, soul);
  
    } catch (error) {
      console.error('Erro ao abrir o perfil:', error);
    }
    return this.souls;
  }

  private async createProfileModal(soul: any) {
    return this.modalCtrl.create({
      component: ProfileDisplayPage,
      componentProps: { theSoul: soul },
    });
  }
  
  private async handleModalResponse(modal: HTMLIonModalElement, soul: any): Promise<void> {
    // Primeiro, apresenta o modal
    await modal.present();
  
    // Depois, espera o fechamento do modal
    const { data } = await modal.onDidDismiss();
  
    if (data === 'logout') {
      this.goToLoginPage();
    }
    // Remove a alma da lista se for "removed"
    else if (data === 'removed') {
      this.removeSoul(soul);
    } 
    // Desenvolva outras ações, como "liked", se necessário
    // else if (data === 'liked') {
    //   this.triggerLikeAndRemoveSoulAnimation(soulIndex);
    // }
  }
  
  private removeSoul(soul: any): void {
    const index = this.souls.findIndex(item => item === soul);
    if (index !== -1) {
      this.souls.splice(index, 1);
      console.log('Objeto removido com sucesso:', soul);
    } else {
      console.warn('Objeto não encontrado para remoção:', soul);
    }
  }

  async goToLoginPage() {
    const referralUserId = this.userService.extractReferralUserId(window.location.href);
    if (referralUserId) {
      this.modalCtrl.create({ component: LoginSharedPage, componentProps: { referralUserId } }).then((modal) => {
        modal.present();
      });
    } else {
      this.modalCtrl.create({ component: LoginPage }).then((modal) => {
        modal.present();
      });
    }
  }
}
